import SingleSignOn from './components/SingleSignOn/SingleSignOn';
import { OpendataDatasetView } from './components/views';

const applyConfig = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    OpendataDataset: OpendataDatasetView,
  };

  config.settings = {
    ...config.settings,
    // matomoSiteId: 'xxxxxxxxx',
    // matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Città della Spezia',
      siteSubtitle: "Medaglia d'oro al Merito Civile",
      site2ndSubtitle: "Medaglia d'argento al Valor Militare",
      parentSiteTitle: 'Regione Liguria',
      parentSiteURL: 'https://www.regione.liguria.it/',
      subsiteParentSiteTitle: 'Città della Spezia',
      // enableCustomerSatisfaction: false, // false per disabilitare
      arLoginUrl: 'https://istanze.comune.laspezia.it',
    },

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
        text: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.text,
          it: {
            ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.text.it,
            description:
              "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti. Per saperne di più consulta la nostra <a href='/informativa-privacy' target='_blank'>Privacy Policy.</a>",
          },
        },
        last_updated: '2023-06-14T12:43:00+00:00',
        technical: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
          choices: [
            {
              config_key: 'MATOMO',
              text: {
                it: {
                  title: 'Web Analytics Italia',
                  description:
                    "I cookie di Web Analytics Italia sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
                },
                // en: {
                //   title: 'Web Analytics Italia',
                //   description:
                //     'Web Analytics Italia cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
                // },
                // fr: {
                //   title: 'Web Analytics Italia',
                //   description:
                //     'Web Analytics Italia cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
                // },
              },
            },
            // ...config.settings[
            //   'volto-gdpr-privacy'
            // ].defaultPanelConfig.technical.choices.filter(
            //   (f) => f.config_key !== 'GANALYTICS',
            // ),
          ],
        },
        profiling: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.profiling,
          choices: [],
        },
      },
    },
  };

  config.settings.siteProperties.userLoggedMenu = [
    // overrides volto-io-prenoto
    // ...(config.settings.siteProperties.userLoggedMenu || []),
    {
      href: { it: 'https://istanze.comune.laspezia.it/area-utente/scrivania' },
      // title: { it: 'Area personale' },
      title: { it: 'Le mie istanze' },
      roles: [],
      className: 'link-areaPersonale',
    },
  ];

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: SingleSignOn,
      props: {
        // checkssoUrl: 'http://localhost:3000/++api++',
        checkssoUrl: 'https://pratiche.comune.laspezia.it/SP/IsAut',
      },
    },
  ];
  return config;
};

export default applyConfig;
